module.exports = __webpack_public_path__ + "static/media/img-works-03.d0777cdf.jpg";